import { theme } from 'lib';

const getRoleBgColor = (userType) => {
  const BG_COLORS = {
    team: theme.DARK_PURPLE,
    athlete: theme.SECONDARY,
    fan: theme.DARK_BLUE
  };

  return BG_COLORS[userType]
    ? `linear-gradient(to bottom, ${BG_COLORS[userType]}, #000, #000)`
    : '#000';
};

export default getRoleBgColor;
